import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AuthUser() {
	const navigate = useNavigate();

	const getToken = () => {
		const tokenString = sessionStorage.getItem('adminbear');
		const userToken = JSON.parse(tokenString);
		return userToken;
	}

	const getUser = () => {
		const userString = sessionStorage.getItem('user');
		const user_detail = JSON.parse(userString);
		return user_detail;
	}



	const [token, setToken] = useState(getToken());
	const [user, setUser] = useState(getUser());

	const saveToken = (user, token) => {
		sessionStorage.setItem('adminbear', JSON.stringify(token));
		sessionStorage.setItem('user', JSON.stringify(user));

		setToken(token);
		setUser(user);
		navigate('/dashboard');
	}

	const logout = () => {
		sessionStorage.clear();
		navigate('/login');
	}

	return {
		setToken: saveToken,
		token,
		user,
		getToken,
		logout
	}
}